import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["amount", "serviceSelect", "serviceId"]

  connect() {
    // Initialize with service price if available
  }

  serviceChanged(event) {
    const selectedOption = event.target.selectedOptions[0]

    if (selectedOption && selectedOption.dataset.price) {
      const price = selectedOption.dataset.price

      if (this.hasAmountTarget) {
        this.amountTarget.value = price
      }

      // Update hidden service_id field if present
      if (this.hasServiceIdTarget) {
        this.serviceIdTarget.value = selectedOption.value
      }
    }
  }
}
